import { useEffect, useState } from "react";
import { FlaskConical, UserPlus, RotateCcw, Activity } from "lucide-react";
import { api } from "@/lib/api";
import { MovementChart } from "@/components/dashboard/MovementChart";

const Conversion = ({ c }) => (
  <div data-testid="movement-conversion" className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border border-emerald-500/30 bg-emerald-500/[0.06] px-4 py-2.5 text-sm">
    <span className="font-semibold text-emerald-200">Taxa de conversão</span>
    <span data-testid="movement-conversion-rate" className="font-mono text-xl font-extrabold text-white">{c.rate == null ? "—" : `${c.rate.toLocaleString("pt-BR")}%`}</span>
    <span className="text-xs text-slate-400">{c.converted} de {c.trials} testes criados no período já viraram assinatura</span>
  </div>
);

const TABS = [["hoje", "Hoje"], ["ontem", "Ontem"], ["semana", "Semana"], ["mes", "Mês"]];
const COLS = [
  ["teste", "Testes", FlaskConical, "#FBBF24", "novos testes gerados"],
  ["nova", "Novas assinaturas", UserPlus, "#34D399", "clientes novos + testes que viraram clientes"],
  ["reativacao", "Reativações", RotateCcw, "#38BDF8", "clientes vencidos que voltaram a pagar"],
];
const ACCS = ["csalpha", "alpha2", "alpha4", "wetester"];

const Col = ({ k, title, icon: Icon, color, hint, blk }) => (
  <div data-testid={`movement-${k}`} className="rounded-xl border border-[#1F293D] bg-[#0F141F] p-4">
    <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-wider text-slate-400">
      {title}<span className="rounded-lg p-1.5" style={{ background: `${color}1A` }}><Icon className="h-4 w-4" style={{ color }} /></span>
    </div>
    <div data-testid={`movement-${k}-total`} className="mt-2 font-mono text-3xl font-extrabold text-white">{blk.total}</div>
    <div className="text-[11px] text-slate-500">{hint}</div>
    <div className="mt-3 grid grid-cols-2 gap-x-3 gap-y-1">
      {[...ACCS, ...Object.keys(blk.by).filter((a) => !ACCS.includes(a))].map((a) => (
        <div key={a} data-testid={`movement-${k}-${a}`} className="flex justify-between text-xs">
          <span className="text-slate-500">{a}</span><span className="font-mono font-bold text-slate-200">{blk.by[a] || 0}</span>
        </div>
      ))}
    </div>
  </div>
);

export const MovementCard = () => {
  const [d, setD] = useState(null);
  const [tab, setTab] = useState("hoje");
  useEffect(() => {
    const load = () => api.get("/stats/movement").then((r) => setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);
  if (!d) return null;
  const p = d.periods[tab];
  const range = p.from === p.to ? p.from.split("-").reverse().join("/") : `${p.from.slice(8)}/${p.from.slice(5, 7)} a ${p.to.slice(8)}/${p.to.slice(5, 7)}`;
  return (
    <div data-testid="movement-card" className="rounded-2xl border border-[#1F293D] bg-[#111827] p-5 fade-up">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h3 className="flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-slate-200">
          <Activity className="h-4 w-4 text-emerald-400" /> Movimento de clientes <span className="font-normal normal-case text-slate-500">· {range}</span>
        </h3>
        <div className="flex rounded-lg border border-[#1F293D] bg-[#0B0F17] p-0.5">
          {TABS.map(([k, l]) => (
            <button key={k} data-testid={`movement-tab-${k}`} onClick={() => setTab(k)}
              className={`rounded-md px-3 py-1 text-xs font-semibold transition-colors ${tab === k ? "bg-emerald-500 text-slate-950" : "text-slate-400 hover:text-white"}`}>{l}</button>
          ))}
        </div>
      </div>
      <div className="grid gap-3 md:grid-cols-3">
        {COLS.map(([k, title, icon, color, hint]) => <Col key={k} k={k} title={title} icon={icon} color={color} hint={hint} blk={p[k]} />)}
      </div>
      {p.conversion && <Conversion c={p.conversion} />}
      {d.daily && <MovementChart daily={d.daily} />}
    </div>
  );
};
